import api from "./axios";

// GET /api/images?vehicleId=…
export async function getImages({ vehicleId } = {}) {
  return api
    .get(`/images`, {
      // only send vehicleId if defined
      params: vehicleId ? { vehicleId } : undefined,
    })
    .then((res) => res.data);
}

// POST /api/images (multipart/form-data; body must include vehicleId + files[])
export async function uploadImages(vehicleId, files) {
  const formData = new FormData();
  formData.append("vehicleId", vehicleId);
  files.forEach((file) => formData.append("files", file));

  return api.post(`/images`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

// DELETE /api/images/:id
export async function deleteImage(id) {
  return api.delete(`/images/${id}`).then((res) => res.data);
}

// bulk delete: DELETE /api/images  { ids: [...] }
export async function deleteBulkImages(ids) {
  return api.delete(`/images`, { data: { ids } }).then((res) => res.data);
}

export const setMainImage = (vehicleId, imageId) =>
  api.patch("/images/setMain", { vehicleId, imageId });

export const reorderImages = (orders) => api.patch("/images/order", { orders });

export async function fetchImagesFromAzure(vehicleId, registration) {
  const res = await api.post(`/images/fetch/${vehicleId}`, {
    registration,
  });
  return res.data;
}
